import { useEffect, useRef, useState } from "react";
import { ScrollbarWrapper } from "../../../../../../components/ScrollbarWrapper";
import { useTranslation } from "react-i18next";

const ColorPicker = ({ name, label, value, onChange, required, error, disabled, hint }) => {
    const { t } = useTranslation("common");
    const colors = [
        { id: 1, value: "#F89624" },
        { id: 2, value: "#F89953" },
        { id: 3, value: "#FEC33B" },
        { id: 4, value: "#FFD566" },
        { id: 5, value: "#6180C0" },
        { id: 6, value: "#09BBB5" },
        { id: 7, value: "#86D3E6" },
        { id: 8, value: "#BCD9F2" },
        { id: 9, value: "#8FC73E" },
        { id: 10, value: "#ADD25F" },
        { id: 11, value: "#F26B76" },
        { id: 12, value: "#F7A8B1" },
    ];
    const [dropdownOpen, isDropdownOpen] = useState(false);
    const [color, setColor] = useState(value);
    const [searchTerm, setSearchTerm] = useState("");
    const [windowWidth, setWindowWidth] = useState(window.innerWidth);
    const selectRef = useRef(null);

    const dropdownToggle = () => {
        isDropdownOpen(!dropdownOpen);
    };

    const handleColorChange = (color) => {
        setColor(color);
        onChange({ target: { name, value: color } });
        isDropdownOpen(false);
    };

    const handleSearchChange = (event) => {
        setSearchTerm(event.target.value);
    };

    const handleClickOutside = (event) => {
        if (selectRef.current && !selectRef.current.contains(event.target)) {
            isDropdownOpen(false);
        }
    };

    const handleResize = () => {
        setWindowWidth(window.innerWidth);
    };

    useEffect(() => {
        document.addEventListener("mousedown", handleClickOutside);
        window.addEventListener("resize", handleResize);

        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
            window.removeEventListener("resize", handleResize);
        };
    }, []);

    useEffect(() => {
        setColor(value);
    }, [value]);

    return (
        <>
            <label htmlFor={`input-${name}`} className={`${required ? "input-required" : ""}`}>
                {label}
            </label>
            <div className={`dropdown dropdown--select dropdown--select-colorpicker ${disabled ? "colorpicker-disabled" : ""}`} ref={selectRef}>
                <div className="dropdown__toggle" onClick={() => !disabled && dropdownToggle()}>
                    <span style={{ backgroundColor: color, width: "20px", height: "20px", borderRadius: "20%", marginRight: "5px" }}>
                        {color === undefined || color === "" ? <i class="fa-light fa-palette"></i> : ""}
                    </span>
                    {color}
                </div>
                <div className={`dropdown__menu ${dropdownOpen ? "active" : ""}`}>
                    <input type="text" class="dropdown__menu__search" placeholder={t("search")} value={searchTerm} onChange={handleSearchChange} disabled={disabled}/>
                    <ScrollbarWrapper
                        id="mainContentScrollbar"
                        className="dropdown__menu__wrap"
                        options={{
                            removeXTrack: true,
                        }}
                    >
                        {colors.map((color) => (
                            <div
                                className="dropdown__menu__item"
                                key={color.id}
                                data-color={color.value}
                                onClick={() => {
                                    if (!disabled) handleColorChange(color.value);
                                }}
                                style={{ display: color.value.toLowerCase().includes(searchTerm.toLowerCase()) ? "" : "none" }}
                            >
                                {color.value}
                            </div>
                        ))}
                    </ScrollbarWrapper>
                </div>
            </div>
            {hint && <div className="hint-message-text">{hint}</div>}
            {error && <div className="error-message-text">{error}</div>}
        </>
    );
};

export default ColorPicker;
